/**
 * Created by iamso on 18.02.2022
 *
 * regular GridLayout supports only a rigid grid pattern https://gyazo.com/847b4fcb8763b8ff143504a1041ad469
 * WrapGridLayout is dynamic https://gyazo.com/b832fbb2997aa0ff70b9c55614c9981b
 */

cleverapps.WrapGridLayout = cleverapps.GridLayout.extend({
    reshape: function () {
        this.items.forEach((node) => {
            node.removeTemporarily(false);
        });

        this.removeAllChildren();
        this.splitItemsInRows();

        const rowNodes = this.rows.map((rowItems, index) => {
            if (this.options.separator.horizontal) {
                rowItems = rowItems.slice(0, 1).concat(
                    rowItems.slice(1).map((item) => [new cc.Sprite(this.options.separator.horizontal), item])
                ).flat();
            }
            const rowNode = new cleverapps.Layout(rowItems, {
                direction: cleverapps.UI.HORIZONTAL,
                margin: this.options.margin.x
            });
            if (this.options.ascZOrder) {
                rowNode.setLocalZOrder(this.rows.length - index);
            }

            return rowNode;
        });

        const gridNode = new cleverapps.Layout(rowNodes, { 
            direction: cleverapps.UI.VERTICAL,
            margin: this.options.margin.y,
            padding: this.options.padding,
            reversed: true
        });

        this.setContentSize(gridNode.getContentSize());
        this.addChild(gridNode);
        gridNode.setAlignment(this.width / 2, this.height / 2);

        if (this.options.fitToBox) {
            cleverapps.UI.fitToBox(this, this.options.fitToBox);
        }
    }
});